export const dataHooks = {
    input: 'file-upload-input',
};
//# sourceMappingURL=constants.js.map